import styled from 'styled-components';

export const FiltersWrapper = styled.div`
    padding: 10px;
    border: 1px solid #ddd;
`;